import React, {useEffect} from 'react'
import {Header,Container} from '../styles/style.js'
import {IntroductionBackground} from '../styles/form.js'
import WriteDB from '../API/WriteDB.js'

const writeDB = new WriteDB()
export default function FinalPage(props){
    useEffect(()=>{
        deleteLink()
        async function deleteLink(){
            await writeDB.deleteLink();
        }
    },[])

    return(
        <IntroductionBackground>
            <Container>
                <Header style={{color:'white'}}>
                    Thank you for answering all of the forms. The results have been submitted
                </Header>
            </Container>
        </IntroductionBackground>
    )
}
